// extracted by mini-css-extract-plugin
export default {"wrapper":"f3-z"};